import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Clients from "./pages/Clients";
import ClientDetail from "./pages/ClientDetail";
import ClientForm from "./pages/ClientForm";
import Cites from "./pages/Cites";
import Users from "./pages/Users";
import Settings from "./pages/Settings";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route
                            path="/"
                            element={
                                <ProtectedRoute>
                                    <Dashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/clients"
                            element={
                                <ProtectedRoute>
                                    <Clients />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/clients/new"
                            element={
                                <ProtectedRoute>
                                    <ClientForm />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/clients/:id"
                            element={
                                <ProtectedRoute>
                                    <ClientDetail />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/clients/:id/edit"
                            element={
                                <ProtectedRoute>
                                    <ClientForm />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/cites"
                            element={
                                <ProtectedRoute>
                                    <Cites />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/utilisateurs"
                            element={
                                <ProtectedRoute adminOnly>
                                    <Users />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/parametres"
                            element={
                                <ProtectedRoute adminOnly>
                                    <Settings />
                                </ProtectedRoute>
                            }
                        />
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
